<!--
    Props
        - dialog_opened - Controla o estado de visibilidade do dialog
        - title - Titulo principal da caixa do modal
        - message - Mensagem principal do dialogo
        - btn_1_text - First button text        
        - btn_2_text - First button text
    Events
        - btn_1_clicked - Disparado quando o botão 1 é clicado
        - btn_2_clicked - Disparado quando o botão 2 é clicado
-->
<template>
  <v-dialog v-model="t__dialog_opened" persistent max-width="390">
    <v-card>
      <v-card-title class="headline">{{t__title}}</v-card-title>
      <v-card-text v-html="t__message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="t__btn_1_text"
          :color="t__btn_1_color"
          text
          @click="fn_btn_1_clicked"
        >{{t__btn_1_text}}</v-btn>
        <v-btn
          v-if="t__btn_2_text"
          :color="t__btn_2_color"
          text
          @click="fn_btn_2_clicked"
        >{{t__btn_2_text}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialog_opened: Boolean,
    title: String,
    message: String,
    btn_1_text: String,
    btn_2_text: String
  },
  data() {
    return {
      show_used: false,
      t__dialog_opened: false,
      t__title: "",
      t__message: "",
      t__btn_1_text: null,
      t__btn_1_color: 'green darken-1',
      t__btn_2_text: null,
      t__btn_2_color: 'green darken-1',
      btn_1_action: function() {},
      btn_2_action: function() {}
    };
  },
  updated() {
    if (this.show_used) {
      return;
    }
    if (this.dialog_opened != null) this.t__dialog_opened = this.dialog_opened;
    if (this.title != null) this.t__title = this.title;
    if (this.message) this.t__message = this.message;
    if (this.btn_1_text != null) this.t__btn_1_text = this.btn_1_text;

    if (this.btn_2_text != null) this.t__btn_2_text = this.btn_2_text;
  },
  methods: {
    hide() {
      this.t__dialog_opened = false;
    },
    show(title, message, btn_1_text = null, btn_2_text = null, params={}) {
      if (typeof title != "object") {
        this.t__title = title;
        this.t__message = message;
        this.t__btn_1_text = btn_1_text;
        this.t__btn_2_text = btn_2_text;
        
      } else {
        var param1 = title;
        this.t__title = param1.title;
        this.t__message = param1.message;
        this.t__btn_1_text = param1.btn_1_text;
        this.t__btn_2_text = param1.btn_2_text;
        if (param1.btn_1_action) {
          this.btn_1_action = param1.btn_1_action;
        }
        if (param1.btn_2_action) {
          this.btn_2_action = param1.btn_2_action;
        }

        params = typeof param1.params == 'object' ? param1.params : {}
      }

      if(params.btn_1_color){
        this.t__btn_1_color = params.btn_1_color;
      }

      if(params.btn_2_color){
        this.t__btn_2_color = params.btn_2_color;
      }

      this.t__dialog_opened = true;
      this.show_used = true;
    },
    fn_btn_1_clicked() {
      if (this.show_used) {
        this.t__dialog_opened = false;
      }
      this.btn_1_action();
      this.$emit("btn_1_clicked");
      this.show_used = false;
    },
    fn_btn_2_clicked() {
      if (this.show_used) {
        this.t__dialog_opened = false;
      }
      this.btn_2_action();
      this.$emit("btn_2_clicked");
      this.show_used = false;
    }
  }
};
</script>